<template>
  <div class="app-layout-container">
    <!-- :message="'It may take up to '" -->
    <LoadingPlaceholder
      v-if="loading"
      :header="'Loading of pdf report'"
    />

    <modal
      name="report-modal"
      :adaptive="true"
      :height="'auto'"
      width="80%"
    >
      <div class="modal-container">
        <div class="content">
          PDF report successfully downloaded
        </div>
        <div
          class="footer"
          @click="$modal.hide('report-modal')"
        >
          OK
        </div>
      </div>
    </modal>

    <div class="top-menu">
      <!--
        // TODO : auto show back button feature temporarily disable
        v-if="prevRoute || arrowLeftVisible"
      -->
      <div
        v-if="arrowLeftVisible"
        class="buttons-group"
      >
        <ArrowLeft
          v-show="arrowLeftVisible"
          @click.native="onArrowLeftClick"
        />
      </div>
      <div class="title">
        {{ title }}
      </div>
      <div class="buttons-group pull-right">
        <DownloadIcon
          v-show="downloadButtonVisible"
          @click.native="onClickDownloadButton"
        />
      </div>
    </div>
    <div class="content">
      <div class="inner-content">
        <slot name="content" />
      </div>
    </div>
    <div class="bottom-menu">
      <div
        v-for="menu in menuItems"
        :key="menu.key"
        class="icon-container"
        @click="onClickMenuItem(menu)"
      >
        <div class="icon">
          <component
            :is="menu.comp"
            :fill="menu.color"
          />
        </div>
        <div
          class="label"
          :style="{ color: menu.color }"
        >
          {{ menu.label }}
        </div>
      </div>
    </div>

    <div
      v-if="floatMenusVisible"
      class="hidden-menu-background"
      @click="onClickHiddenMenuBackground"
    />

    <div
      v-if="floatMenusVisible"
      class="hidden-menu"
    >
      <div
        v-for="menu in floatMenuItems"
        :key="menu.label"
        class="menu-item"
        @click="menu.clickHandler"
      >
        <div class="icon">
          <component :is="menu.component" />
        </div>
        <div class="label">
          {{ menu.label }}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { RouteIcon, StatsIcon } from './MenuIcons';
import { CSSConstants } from '@moeco-platform/moeco-components';
import DownloadIcon from './TopMenuIcons/DownloadIcon';
import ArrowLeft from './Icons/ArrowLeft';
import LinkIcon from '@/components/Icons/LinkIcon';
import ReportIcon from '@/components/Icons/ReportIcon';
import { exportReport } from '@/helpers/export';
import LoadingPlaceholder from '@/components/LoadingPlaceholder';
export default {
  components: {
    ArrowLeft,
    DownloadIcon,
    LinkIcon,
    ReportIcon,
    LoadingPlaceholder,
  },
  data() {
    return {
      loading: false,
      floatMenuItems: [
        {
          label: 'Copy link to the desktop version',
          component: LinkIcon,
          clickHandler: this.onClickLink,
        },
        {
          label: 'Download the report (PDF file)',
          component: ReportIcon,
          clickHandler: this.onClickReport,
        },
      ],

      menuItems: [
        {
          comp: StatsIcon,
          label: 'Stats',
          id: 'stats',
          routeName: 'stat',
          active: false,
          color: CSSConstants.GREY_70,
        },
        {
          comp: RouteIcon,
          label: 'Route',
          id: 'route',
          routeName: 'map',
          active: false,
          color: CSSConstants.GREY_70,
        },

        // TODO: Not implemented, but will be soon
        // {
        //   comp: StagesIcon,
        //   label: "Stages",
        //   id: "stages",
        //   routeName: "",
        //   active: false,
        //   color: CSSConstants.GREY_70,
        // },
      ],
    };
  },

  computed: {
    ...mapGetters({
      title: 'layout/title',
      activeMenu: 'layout/activeMenu',
      currentRoute: 'layout/currentRoute',
      reportBuffer: 'packageDetails/report/reportBuffer',

      // TODO : auto show back button feature temporarily disable
      // prevRoute: "layout/prevRoute",

      downloadButtonVisible: 'layout/downloadButtonVisible',
      floatMenusVisible: 'layout/floatMenusVisible',
      arrowLeftVisible: 'layout/arrowLeftVisible',
      arrowLeftPreventDefault: 'layout/arrowLeftPreventDefault',

      // TODO: move outside
      track: 'packageDetails/track/list',
      sensorUid: 'shipments/sensorUid',
    }),
  },

  watch: {
    activeMenu() {
      this.trackCurrentMenuItemByKey('id');
    },

    currentRoute: {
      immediate: true,
      handler: function () {
        if (!this.currentRoute) return;

        const foundMenuItem = this.findMenuItem(
          'routeName',
          this.currentRoute.name
        );

        this.activateMenuItem(foundMenuItem);

        // TODO : auto show back button feature temporarily disable
        // if (this.prevRoute) {
        //   if (this.prevRoute.name !== this.currentRoute.name) {
        //     this.setArrowLeftVisible(true);
        //   }
        // }
      },
    },
  },

  methods: {
    ...mapActions({
      exportPdf: 'packageDetails/report/exportPdf',
    }),
    ...mapMutations({
      setActiveMenu: 'layout/setActiveMenu',
      setArrowLeftVisible: 'layout/setArrowLeftVisible',
      emitBackButtonClickEvent: 'layout/emitBackButtonClickEvent',
      setFloatMenusVisible: 'layout/setFloatMenusVisible',
    }),

    onClickLink() {
      const device_hash = this.track[0]._source.device_hash;

      let baseurl = process.env.VUE_APP_CUSTOMER_DASHBOARD_BASE_LINK;

      if (baseurl[baseurl.length - 1] === '/') {
        baseurl = baseurl.slice(0, -1);
      }

      const url = baseurl + '/' + device_hash;

      if (navigator.share) {
        navigator
          .share({
            title: 'Share link',
            url,
          })
          .then(() => {
            console.log('Thanks for sharing!');
          })
          .catch(console.error);
      } else {
        // fallback
      }
    },
    async onClickReport(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      this.setFloatMenusVisible(false);

      try {
        this.loading = true;
        await this.exportPdf(this.sensorUid);
        exportReport(this.reportBuffer.data, 'report', ev);
        this.$modal.show('report-modal');
      } catch (error) {
        console.log('error', error);
      } finally {
        this.loading = false;
      }
    },

    onClickDownloadButton() {
      this.setFloatMenusVisible(!this.floatMenusVisible);
    },

    onClickHiddenMenuBackground() {
      this.setFloatMenusVisible(false);
    },

    onArrowLeftClick() {
      this.emitBackButtonClickEvent();

      if (this.arrowLeftPreventDefault) {
        return;
      }
    },

    trackCurrentMenuItemByKey(key) {
      this.deactivateAllMenuItems();
      const foundMenuItem = this.findMenuItem(key, this.activeMenu.id);
      this.activateMenuItem(foundMenuItem);
      this.setActiveRouterView(foundMenuItem);
    },

    findMenuItem(key, value) {
      const foundMenuItem = this.menuItems.find(
        (menuItem) => menuItem[key] === value
      );
      if (!foundMenuItem) {
        throw new Error(' Wrong menu item: ' + JSON.stringify(foundMenuItem));
      }
      return foundMenuItem;
    },

    setActiveRouterView(menuItem) {
      const { routeName: name } = menuItem;
      if (this.$route.name !== name) {
        if (!name) {
          throw new Error('Wrong menu item route: ', JSON.stringify(menuItem));
        }
        this.$router.push({ name, query: this.$route.query });
      }
    },

    deactivateAllMenuItems() {
      this.menuItems.forEach((m) => {
        m.color = CSSConstants.GREY_70;
        m.active = false;
      });
    },

    activateMenuItem(menuItem) {
      menuItem.active = true;
      menuItem.color = CSSConstants.ACCENT_BLUE;
    },

    onClickMenuItem(menu) {
      this.setActiveMenu(menu);
    },
  },
};
</script>



<style scoped lang="scss">
.modal-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  // padding: 16px;

  color: $notBlack;

  .content {
    text-align: center;
    padding: 8px;
  }

  .footer {
    border-top: 1px solid $grey10;
    text-align: center;
    padding: 8px;
    color: $accentBlue;
  }
}

.app-layout-container {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  color: $notBlack;

  .top-menu {
    min-height: 50px;
    max-height: 50px;
    width: 100%;

    border-bottom: 1px solid $grey50;

    display: flex;
    align-items: center;
    padding: 0 20px;

    .title {
      @include h3;
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
    }

    .buttons-group {
      display: flex;
      align-items: center;

      &.pull-right {
        margin-left: auto;
      }
    }
  }

  .content {
    flex: 1;
    position: relative;

    .inner-content {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }

  .bottom-menu {
    border-top: 1px solid $grey50;
    min-height: 70px;
    max-height: 70px;
    width: 100%;

    display: flex;

    // justify-content: space-between;
    justify-content: space-around;
    align-items: center;
    padding: 0 50px;

    .icon-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .label {
        color: $grey70;
        font-size: 10px;
        line-height: 12px;
        &.selected {
          color: $accentBlue;
        }
      }
    }
  }

  .hidden-menu-background {
    position: absolute;

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background: $notBlack;

    opacity: 0.5;
    z-index: 10000;
  }

  .hidden-menu {
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12),
      0px 16px 16px rgba(0, 0, 0, 0.24);

    position: absolute;
    bottom: 0;

    width: 100%;
    height: 120px;
    z-index: 11000;
    background: #fafafa;
    opacity: 1;

    $padding: 15px;
    .menu-item {
      display: flex;
      align-items: center;

      user-select: none;
      height: 50px;

      .icon {
        display: flex;
        // padding: $padding;
        margin-right: $padding;
        margin-left: $padding;
      }

      .label {
        // padding-top: $padding;
        // padding-bottom: $padding;
      }
    }
  }
}
</style>